import { ANIMATION_TYPES } from '@website-editor/context/NavigationPaneContext/NavigationPane.constants';

// Const object + type alias replaces the former enum so that
// (a) the type lives in a type-only file (.types.ts) and
// (b) call sites can continue using CustomComponentsWrapperType.EditComponentList syntax.
export const CustomComponentsWrapperType = {
  SingleComponent: 'singleComponent',
  EditComponentList: 'editComponentList',
  AddComponentList: 'addComponentList',
} as const;
export type CustomComponentsWrapperType = (typeof CustomComponentsWrapperType)[keyof typeof CustomComponentsWrapperType];

export enum CUSTOM_PAGE_ACTIONS {
  CUSTOM_COMPONENTS = 'custom_components',
  CUSTOM_COMPONENTS_ADD = 'custom_components_add',
  CUSTOM_COMPONENTS_EDIT = 'custom_components_add_edit',
}

export const CUSTOM_PAGE_SCREENS = [CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS, CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS_ADD, CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS_EDIT];

export const CUSTOM_PAGE_ANIMATION_CONFIG = {
  [CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS]: [
    {
      navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS_ADD,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
    {
      navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS_EDIT,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
  [CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS_ADD]: [
    {
      navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
    {
      navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS_ADD,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
  [CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS_EDIT]: [
    {
      navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
};
